import { createAction, createSlice } from '@reduxjs/toolkit';

import { findApplicationTasks, getTaskDetails } from './tasksSlice';

export interface ICurrentApplicationDataState {
  taskIds: string[] | null;
  selectedTaskData: {
    commentIds: string[] | undefined;
    documentIds: string[] | undefined;
  };
  previousApplicationStatusId: string | null;
  isSubmitInProgress: boolean;
  offersVariable: string | null;
}

const initialState: ICurrentApplicationDataState = {
  taskIds: null,
  selectedTaskData: {
    commentIds: undefined,
    documentIds: undefined,
  },
  previousApplicationStatusId: null,
  isSubmitInProgress: false,
  offersVariable: null,
};

export const resetSelectedTaskData = createAction('currentApplication/resetSelectedTaskData');
export const setCurrentApplicationData = createAction<Partial<ICurrentApplicationDataState>>('currentApplication/setCurrentApplicationData');

const currentApplicationDataSlice = createSlice({
  name: 'currentApplicationDataSlice',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(findApplicationTasks.fulfilled, (state, { payload }) => {
        state.taskIds = payload.map((task) => task.id);
      })
      .addCase(getTaskDetails.fulfilled, (state, { payload }) => {
        state.selectedTaskData.commentIds = payload.comments.map((comment) => comment.id);
        state.selectedTaskData.documentIds = payload.documents.map((document) => document.id);
      })
      .addCase(resetSelectedTaskData, (state) => {
        state.selectedTaskData = {
          commentIds: undefined,
          documentIds: undefined,
        };
      })
      .addCase(setCurrentApplicationData, (state, { payload }) => {
        Object.assign(state, payload);
      });
  },
});

export default currentApplicationDataSlice.reducer;
